import { SvgIcon } from "@mui/material";
import PropTypes from "prop-types";

const ArrowRightIcon = ({ fill = "currentColor", ...props }) => {
  return (
    <SvgIcon viewBox="0 -10 30 11" {...props}>
      <path
        d="M20 5.26953C20 5.62109 19.9349 5.94661 19.8047 6.24609C19.6745 6.54557 19.4987 6.8125 19.2773 7.04688L16.0547 10.2695C15.9766 10.3477 15.8854 10.4128 15.7812 10.4648C15.6771 10.5039 15.5729 10.5234 15.4687 10.5234C15.3516 10.5234 15.2409 10.5039 15.1367 10.4648C15.0326 10.4128 14.9479 10.3477 14.8828 10.2695C14.8047 10.2044 14.7396 10.1198 14.6875 10.0156C14.6484 9.91146 14.6289 9.80078 14.6289 9.68359C14.6289 9.57943 14.6484 9.47526 14.6875 9.37109C14.7396 9.26693 14.8047 9.17578 14.8828 9.09766L17.8906 6.08984L0.839844 6.08984C0.605469 6.08984 0.403646 6.01172 0.234375 5.85547C0.078125 5.6862 0 5.48438 0 5.25C0 5.01562 0.078125 4.82031 0.234375 4.66406C0.403646 4.49479 0.605469 4.41016 0.839844 4.41016L17.832 4.41016L14.8633 1.42188C14.7852 1.34375 14.7266 1.25911 14.6875 1.16797C14.6484 1.0638 14.6289 0.953125 14.6289 0.835938C14.6289 0.71875 14.6484 0.614583 14.6875 0.523438C14.7266 0.419271 14.7852 0.328125 14.8633 0.25C14.9414 0.171875 15.026 0.113281 15.1172 0.0742188C15.2214 0.0221354 15.332 -0.00390625 15.4492 -0.00390625C15.5664 -0.00390625 15.6706 0.0221354 15.7617 0.0742188C15.8659 0.113281 15.957 0.171875 16.0352 0.25L19.2578 3.51172C19.4922 3.73307 19.668 4 19.7852 4.3125C19.9154 4.61198 19.9805 4.93099 19.9805 5.26953H20Z"
        fill={fill}
      />
    </SvgIcon>
  );
};

ArrowRightIcon.propTypes = {
  fill: PropTypes.string,
};

export default ArrowRightIcon;
